import tippy from "tippy.js";

// Focus opens a tooltip only for someone tabbing through the page. Chrome also
// focuses an element when it is clicked, and a modal's focus trap hands that
// focus straight back when it closes — with no pointer left to leave, the
// tooltip would stay on screen for good. `:focus-visible` cannot tell the two
// apart, because Chrome reports the restored focus as focus-visible; the
// keystroke that moved focus can.
let focusFollowsTab = false;

document.addEventListener(
  "keydown",
  (event) => {
    focusFollowsTab = event.key === "Tab";
  },
  true
);

document.addEventListener(
  "pointerdown",
  () => {
    focusFollowsTab = false;
  },
  true
);

function createTooltip(element, value) {
  if (!element.hasAttribute("aria-label")) {
    element.setAttribute("aria-label", value);
  }

  let triggeredByFocus = false;

  tippy(element, {
    content: value,
    theme: "custom",
    arrow: '<div class="tooltip-arrow"></div>',
    trigger: "mouseenter focus",
    onTrigger: (_instance, event) => {
      triggeredByFocus = event.type === "focus";
    },
    onShow: () => !triggeredByFocus || focusFollowsTab,
    delay: [500, 0],
    animation: "tooltip",
    duration: 150,
  });
}

export const tooltip = {
  mounted(element, binding) {
    const { value } = binding;

    if (!value) {
      return;
    }

    createTooltip(element, value);
  },

  updated(element, binding) {
    const { value, oldValue } = binding;

    if (!value) {
      if (oldValue) {
        if (element.getAttribute("aria-label") === oldValue) {
          element.removeAttribute("aria-label");
        }
        element._tippy.destroy();
      }
    } else if (value !== oldValue) {
      if (element._tippy) {
        element._tippy.setContent(value);

        // Keep the accessible name in step with the tooltip, but only while it
        // is still the one we set — an author-provided aria-label wins.
        if (element.getAttribute("aria-label") === oldValue) {
          element.setAttribute("aria-label", value);
        }
      } else {
        createTooltip(element, value);
      }
    }
  },
};
